import PropTypes from 'prop-types';
import { useFieldArray, useFormContext } from 'react-hook-form';
import BaseStaffInfoField from './BaseStaffInfoField';
import StaffInfoInputs from './StaffInfoInputs';

FormStaffInfoField.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
};

export default function FormStaffInfoField({ fieldName, focusedField, setFocusedField, fieldAttributes }) {
  const { control } = useFormContext();

  const { fields } = useFieldArray({
    control,
    name: `${fieldName}.staffMembers`,
  });

  return (
    <BaseStaffInfoField
      fieldName={fieldName}
      fieldAttributes={fieldAttributes}
      toggleFieldName={`${fieldName}.isVacant`}
      toggleLabel="Vacant"
      showModal
      modalLabel="vacant"
      getInputRootFieldNames={() => fields.map((_, index) => `${fieldName}.staffMembers[${index}]`)}
    >
      {({ isEditable }) => (
        <>
          {fields.map((field, index) => (
            <StaffInfoInputs
              key={field.id}
              fieldName={`${fieldName}.staffMembers[${index}]`}
              focusedField={focusedField}
              setFocusedField={setFocusedField}
              fieldAttributes={fieldAttributes}
              isEditable={isEditable}
            />
          ))}
        </>
      )}
    </BaseStaffInfoField>
  );
}
